module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/04-03.ebb5abb4.mp3";